var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header bg-white" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-success px-3",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.SAVE()
                  },
                },
              },
              [
                _vm.count == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _c("span", [_vm._v("Guardar")]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body px-0 py-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-2" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Monto minimo facturable"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group input-group-sm mb-2" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.minimum_billable_amount,
                    expression: "data.minimum_billable_amount",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.minimum_billable_amount ? "is-invalid" : "",
                attrs: { type: "text", placeholder: "0.00" },
                domProps: { value: _vm.data.minimum_billable_amount },
                on: {
                  keypress: _vm.DOUBLE,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.data,
                      "minimum_billable_amount",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(
                _vm.errors.minimum_billable_amount,
                function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Descuento general"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group input-group-sm" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.overall_discount,
                    expression: "data.overall_discount",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.overall_discount ? "is-invalid" : "",
                attrs: { type: "text", placeholder: "0.00" },
                domProps: { value: _vm.data.overall_discount },
                on: {
                  keypress: _vm.DOUBLE,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "overall_discount", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._l(_vm.errors.overall_discount, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Monto de descuento para el primer paquete"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group input-group-sm mb-2" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.amount_first_package,
                    expression: "data.amount_first_package",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.amount_first_package ? "is-invalid" : "",
                attrs: { type: "text" },
                domProps: { value: _vm.data.amount_first_package },
                on: {
                  keypress: _vm.DOUBLE,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.data,
                      "amount_first_package",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.amount_first_package, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Impuesto para facturación masiva"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group input-group-sm mb-2" },
            [
              _vm._m(4),
              _vm._v(" "),
              _c("search-tax", {
                staticStyle: { width: "calc(100% - 31.6px)" },
                attrs: { tax: _vm.data.tax, childclass: "rounded-left-0" },
                model: {
                  value: _vm.data.tax_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "tax_id", $$v)
                  },
                  expression: "data.tax_id",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.tax_id, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("General")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-currency-dollar" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v("\n                            %\n                        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-currency-dollar" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-bank" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }